module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/images/external_url_icon.9c099781.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/images/external_url_icon.png
// module id = 3478
// module chunks = 11